import type { SceneNode } from "../scene/model";
import type { AffineMatrix } from "../geometry/affine";
import {
  frameHandles,
  rotationHandles,
  type Box,
  type Camera,
} from "../native/geometry";
import { corners, nodeMatrix } from "../native/transforms";
export function drawSelection(
  canvas: HTMLCanvasElement,
  nodes: readonly SceneNode[],
  frame: AffineMatrix | null,
  marquee: Box | null,
  camera: Camera,
  width: number,
  height: number,
  dpr: number,
  underlay?: (ctx: CanvasRenderingContext2D) => void,
) {
  if (canvas.width !== Math.round(width * dpr))
    canvas.width = Math.round(width * dpr);
  if (canvas.height !== Math.round(height * dpr))
    canvas.height = Math.round(height * dpr);
  const ctx = canvas.getContext("2d")!;
  ctx.setTransform(1, 0, 0, 1, 0, 0);
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  underlay?.(ctx);
  const outline = (matrix: AffineMatrix) => {
    ctx.beginPath();
    corners(matrix).forEach((p, i) => {
      const x = p.x * camera.zoom + camera.x,
        y = p.y * camera.zoom + camera.y;
      if (i) ctx.lineTo(x, y);
      else ctx.moveTo(x, y);
    });
    ctx.closePath();
    ctx.stroke();
  };
  ctx.strokeStyle = "#99a9e8";
  ctx.lineWidth = 1;
  if (nodes.length > 1) for (const node of nodes) outline(nodeMatrix(node));
  ctx.strokeStyle = "#4162df";
  ctx.fillStyle = "#ffffff";
  if (frame && !marquee) {
    outline(frame);
    for (const p of frameHandles(frame)) {
      const x = p.x * camera.zoom + camera.x,
        y = p.y * camera.zoom + camera.y;
      ctx.fillRect(x - 3.5, y - 3.5, 7, 7);
      ctx.strokeRect(x - 3.5, y - 3.5, 7, 7);
    }
    ctx.strokeStyle = "#8198eb";
    for (const p of rotationHandles(frame, camera.zoom)) {
      ctx.beginPath();
      ctx.arc(
        p.x * camera.zoom + camera.x,
        p.y * camera.zoom + camera.y,
        3,
        0,
        2 * Math.PI,
      );
      ctx.fill();
      ctx.stroke();
    }
  }
  if (marquee) {
    ctx.fillStyle = "rgba(65,98,223,.09)";
    ctx.strokeStyle = "#4162df";
    const args: [number, number, number, number] = [
      marquee.x * camera.zoom + camera.x,
      marquee.y * camera.zoom + camera.y,
      marquee.width * camera.zoom,
      marquee.height * camera.zoom,
    ];
    ctx.fillRect(...args);
    ctx.strokeRect(...args);
  }
}
